import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import Layout from "@components/layout";
import * as c from "./homePage.module.scss";
import classNames from "classnames";
import { HomepageSocialProof, HomepageOneColumn, HomepageVideoCarousel } from "@components/pages/homepage";
import { CTASection, ExploreMangomint, CarouselLarge } from "@components/shared";
import { SeoMetadata } from "@components/shared/seoMetadata";

export default function HomePage() {
  const { contentfulMetadata, contentfulExploreMangomint, carousel, footerCTA, logoSoup } = useStaticQuery(graphql`
    query HomePageQuery {
      contentfulMetadata(id: { eq: "3d3bb0dd-3cab-5fd7-adbe-7ddb0d3d3941" }) {
        ...seoMetadataFields
      }
      contentfulExploreMangomint(id: { eq: "7fa534c2-7a8d-5136-9b99-eccabe8758db" }) {
        businessTypes {
          ...GenericListFields
        }
        features {
          ...GenericListFields
        }
      }
      carousel: contentfulLandingPageSectionCarousel(carouselTitle: { eq: "Homepage Carousel v3" }) {
        carouselHeading
        carouselLabel
        carouselDescription {
          raw
        }
        desktopSlides {
          id
          gatsbyImageData
        }
        mobileSlides {
          id
          gatsbyImageData
        }
        imageLabels
        cta {
          __typename
          ... on ContentfulCtaVideoModal {
            label
            wistiaVideoId
            trackedEventName
            style
            showIcon
          }
          ... on ContentfulCtaButton {
            label
            url
            isExternal
            trackedEventName
            style
            showIcon
            openChat
          }
        }
      }
      logoSoup: contentfulLandingPageSectionLogoSoup(id: { eq: "665609fb-eeeb-5369-a113-69bfba47bee9" }) {
        logos {
          description
          gatsbyImageData(height: 120, quality: 90, layout: CONSTRAINED, formats: [AUTO, WEBP, AVIF])
        }
      }
      footerCTA: contentfulLandingPageSectionFooterCta(contentfulName: { eq: "default" }) {
        ...ctaSectionFields
      }
    }
    fragment GenericListFields on ContentfulGenericList {
      title
      heading
      listItems {
        __typename
        ... on ContentfulListItemExploreFeatures {
          title
          category
          url
          icon {
            gatsbyImageData(width: 104, quality: 90, layout: CONSTRAINED)
          }
        }
      }
    }
  `);

  return (
    <>
      <SeoMetadata {...contentfulMetadata} />

      <Layout className={classNames(c.container, "custom-bg", "cream-header")}>
        <div className={c.wrapper}>
          <div className={c.inner}>
            <CarouselLarge className={c.carouselLarge} isHome={true} {...carousel} />
            <HomepageSocialProof logos={logoSoup?.logos} />
            <HomepageOneColumn />
            <HomepageVideoCarousel />

            <ExploreMangomint {...contentfulExploreMangomint} />

            <CTASection {...footerCTA} />
          </div>
        </div>
      </Layout>
    </>
  );
}

export function Head() {
  return (
    <>
      <body className={c.background} />
    </>
  );
}
